import React, { useMemo } from 'react';
import StarIcon from './assets/StarIcon.png';
import { useSelector } from 'react-redux';
import { useTranslation } from 'hooks/useTranslation';
import { usePreferredPayment } from '../shared/hooks/usePreferredPayment';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { PREFERRED_PAYMENT_METADATA_KEY, PREFERRED_PAYMENT_ENABLED } from '../shared/constants';
import { TRANSLATION_KEYS, STAR_ICON_KEY } from './constants';

import './styles.scss';

export const PreferredPaymentIndicator = ({ paymentMethodId, gatewayName }) => {
  const { isPreferred } = usePreferredPayment(paymentMethodId, gatewayName);
  const { translationMapper } = useTranslation();

  const preferredIcon = useSelector(state => state.assets?.[STAR_ICON_KEY]);
  const translations = useMemo(() => translationMapper(TRANSLATION_KEYS), [translationMapper]);
  const config = useSelector(selectMetadataKeyByRegion(PREFERRED_PAYMENT_METADATA_KEY));

  const iconSrc = preferredIcon ?? StarIcon;
  const isButtonEnabled = config.enable ?? PREFERRED_PAYMENT_ENABLED;

  if (!isButtonEnabled || !isPreferred) return null;

  return (
    <div className="PreferredPaymentIndicator">
      <img src={iconSrc} className='PreferredPaymentButton__Icon' alt='Preferred Payment icon' />
      <p>{translations.PREFERRED_PAYMENT_SELECTED}</p>
    </div>
  );
};